module.exports = __webpack_public_path__ + "static/img/Awindows.280f519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Awindows.png
// module id = ZBT9
// module chunks = 3